import CourseSchedulingModule from './containers/courseSchedulingModule'

export {default as CourseSchedulingModuleLayout} from './components/courseSchedulingModuleLayout'

export default CourseSchedulingModule
